import {
  multiply,
  floor,
  add,
  divide,
  ceil,
} from "../../../../utils/mathUtils";

/**
 * Calculate quantity needed based on room count, per room quantity, and PAR level
 * @param {Object} params - Calculation parameters
 * @param {number} params.roomCount - Number of rooms
 * @param {number} params.perRoom - Quantity per room
 * @param {number} params.par - PAR (Periodic Automatic Replenishment) level
 * @returns {number} Quantity needed (floored to whole number)
 */
export const calcQtyNeeded = ({ roomCount, perRoom, par }) =>
  floor(multiply(roomCount, perRoom, par));

/**
 * Calculate total quantity needed across all items
 * @param {Array} items - Array of items with roomCount, perRoom, and par properties
 * @returns {number} Total quantity needed
 */
export const calcTotalNeeded = items =>
  items.reduce((counter, row) => add(counter, calcQtyNeeded(row)), 0);

/**
 * Calculate recommended case quantity to order
 * @param {number} unitsPerCase - Number of units per case
 * @param {Array} items - Array of items to calculate total needed
 * @returns {number} Recommended case quantity (ceiled to whole number)
 */
export const calcRecommendedCaseQtyOrder = (unitsPerCase, items) =>
  unitsPerCase > 0 ? ceil(divide(calcTotalNeeded(items), unitsPerCase)) : 0;
